import { createReducer } from '@reduxjs/toolkit';

import { Nullable } from 'modules/types/common';
import { normalizedGroupedVisitTypes } from 'store/booking/mappers';

import * as actions from './actions';
import { GroupedVisitType, GroupedVisitTypeError } from './types';

export type GroupedVisitTypesState = Readonly<{
  isFetching: boolean;
  error: Nullable<GroupedVisitTypeError>;
  data: GroupedVisitType[];
}>;

export const groupedVisitTypesInitialState: GroupedVisitTypesState = {
  isFetching: false,
  error: null,
  data: []
};

export const groupedVisitTypesReducer = createReducer(groupedVisitTypesInitialState, {
  [actions.GET_GROUPED_VISIT_TYPES]: state => {
    state.isFetching = true;
    state.error = null;
  },
  [actions.GET_GROUPED_VISIT_TYPES_FAIL]: (state, action) => {
    state.isFetching = false;
    state.error = action.error.response.data;
  },
  [actions.GET_GROUPED_VISIT_TYPES_SUCCESS]: (state, action) => {
    state.isFetching = false;
    state.data = normalizedGroupedVisitTypes(action.payload.data);
  },
  [actions.CLEAR_GROUPED_VISIT_TYPE]: state => {
    state.data = [];
  }
});

export default groupedVisitTypesReducer;
